import React, { useMemo } from 'react';

import { default as CartProductAlias } from 'components/Checkout/Cart/CartProduct/CartProduct';
import CartSelectedGift from 'components/Checkout/Cart/CartGifts/CartSelectedGift';
import CartProposedGifts from 'components/Checkout/Cart/CartGifts/CartProposedGifts';
import CartProposedSpecialOffers from 'components/Checkout/Cart/CartSpecialOffers/CartProposedSpecialOffers';
import CartSelectedSpecialOffer from 'components/Checkout/Cart/CartSpecialOffers/CartSelectedSpecialOffer';
import { CartSpecialOffer, CartOfferedGift, CartProduct } from 'types/Cart';

function CartProductList({
  products,
  selectedSpecialOffers,
  proposedSpecialOffers,
  selectedOfferedGifts,
  proposedOfferedGifts,
}: {
  products?: CartProduct[];
  selectedSpecialOffers?: CartSpecialOffer[];
  proposedSpecialOffers?: CartSpecialOffer[];
  selectedOfferedGifts?: CartOfferedGift[];
  proposedOfferedGifts?: CartOfferedGift[];
}): JSX.Element {
  const availableSelectedOffers = useMemo(() => {
    return selectedSpecialOffers?.filter(offeredGift => {
      return (
        offeredGift.products.length &&
        offeredGift.attributes.isInvisible !== 'O'
      );
    });
  }, [selectedSpecialOffers]);
  const availableSelectedGifts = useMemo(() => {
    return selectedOfferedGifts?.filter(offeredGift => {
      return (
        offeredGift.products.length &&
        offeredGift.attributes.isInvisible !== 'O'
      );
    });
  }, [selectedOfferedGifts]);
  const availableProposedGifts = useMemo(() => {
    return proposedOfferedGifts?.filter(offeredGift => {
      return (
        offeredGift.products.length &&
        offeredGift.attributes.isInvisible !== 'O'
      );
    });
  }, [proposedOfferedGifts]);
  const availableProposedOffers = useMemo(() => {
    return proposedSpecialOffers?.filter(offeredGift => {
      return (
        offeredGift.products.length &&
        offeredGift.attributes.isInvisible !== 'O'
      );
    });
  }, [proposedSpecialOffers]);

  return (
    <>
      {products?.map(product => (
        <CartProductAlias product={product} key={product.sku} />
      ))}
      {availableSelectedOffers?.map(specialOffer => (
        <CartSelectedSpecialOffer
          specialOffer={specialOffer}
          key={specialOffer.attributes.codeAm}
        />
      ))}
      {availableSelectedGifts?.map(gift => (
        <CartSelectedGift selectedGift={gift} key={gift.attributes.codeAm} />
      ))}
      {!!availableProposedGifts?.length && (
        <CartProposedGifts proposedGifts={availableProposedGifts} />
      )}
      {!!availableProposedOffers?.length && (
        <CartProposedSpecialOffers specialOffers={availableProposedOffers} />
      )}
    </>
  );
}

export default CartProductList;
